
	// :style="'width:' + $parent.sidebarWidth + 'px;flex:0 0' + $parent.sidebarWidth + 'px;'"
	export default {
		data() {
			return {}
		}
	}
